import React from 'react';
import { DateTime } from 'luxon';

import { DATE_FORMATS } from '../../lib/utils/constants';
import numberSuffix from '../../lib/utils/number-suffix';

import { Day } from './day.styles';

export enum SelectionType {
	RangeStart = 'range-start',
	RangeMiddle = 'range-middle',
	RangeEnd = 'range-end',
	Single = 'single'
}

export interface DayButtonComponentProps
	extends Pick<React.ButtonHTMLAttributes<any>, 'onClick' | 'tabIndex'> {
	date: string;
	selected?: boolean;
	disabled?: boolean;
	isToday?: boolean;
	selectionType?: SelectionType;
	tabIndex: 0 | -1;
}

const DayButtonComponent: React.FC<DayButtonComponentProps> = ({
	date,
	selected = false,
	selectionType = SelectionType.Single,
	disabled = false,
	isToday = false,
	onClick,
	tabIndex
}) => {
	const localDate = DateTime.fromISO(date);

	const formattedDay = localDate.toFormat(DATE_FORMATS.CALENDAR_DAY);
	const formattedMonth = localDate.toFormat(DATE_FORMATS.CALENDAR_MONTH);
	const label = `${numberSuffix(parseInt(formattedDay, 10))} of ${formattedMonth}`;

	return (
		<Day
			tabIndex={tabIndex}
			onClick={onClick}
			type="button"
			data-cy={`day-component-${localDate.toFormat(DATE_FORMATS.URL_DATE)}`}
			className={`${selected ? `selection-type--${selectionType}` : ''} ${isToday && !disabled ? 'today' : ''}`}
			disabled={disabled}
			aria-label={label}
			role="option">
			{formattedDay}
		</Day>
	);
};

export default DayButtonComponent;
